import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

export interface TestCategoryCreateData {
  name: string;
  config?: any;
  testLayoutParameters?: any;
}

export interface TestCategory {
  id: number;
  name: string | null;
  sortOrder: number | null;
  weigtage: number | null;
  testWeigtage: number | null;
  calculateTotal: number | null;
  displayQuestionAnalysis: number | null;
  displaySolution: number | null;
  questionTypeAnalysis: number | null;
  testSectionAnalysis: number | null;
  sectionalTestTimeDistribution: number | null;
  prematureTermination: number | null;
  rankInDossier: number | null;
  gradeEntry: number | null;
  attendanceEntry: number | null;
  gradeValidation: string | null;
  displayCalculatedGrade: number | null;
  displayInPortal: number | null;
  batchRank: string | null;
  schoolRank: string | null;
  testRank: string | null;
  manualRank: string | null;
  remarksAllowed: number | null;
  courseOptionBased: number | null;
  questionNumberDisplayFormat: number | null;
  doNotComputeRank: number | null;
  proctored: number | null;
  invalidateLowestSection: number | null;
  numberOfSectionsToInvalidate: string | null;
  allowAdminToEnableRetake: number | null;
  allowAddingOfTestQuestionRules: number | null;
  dontShowMarksAndRank: number | null;
  marksMessage: string | null;
  config: any;
  testLayoutParameters: any;
  enableStatus: number;
}

export interface TestCategoryUpdateData {
  name?: string;
  sortOrder?: number;
  weigtage?: number;
  testWeigtage?: number;
  calculateTotal?: number;
  displayQuestionAnalysis?: number;
  displaySolution?: number;
  questionTypeAnalysis?: number;
  testSectionAnalysis?: number;
  sectionalTestTimeDistribution?: number;
  prematureTermination?: number;
  rankInDossier?: number;
  gradeEntry?: number;
  attendanceEntry?: number;
  gradeValidation?: string;
  displayCalculatedGrade?: number;
  displayInPortal?: number;
  batchRank?: string;
  schoolRank?: string;
  testRank?: string;
  manualRank?: string;
  remarksAllowed?: number;
  courseOptionBased?: number;
  questionNumberDisplayFormat?: number;
  doNotComputeRank?: number;
  proctored?: number;
  invalidateLowestSection?: number;
  numberOfSectionsToInvalidate?: string;
  allowAdminToEnableRetake?: number;
  allowAddingOfTestQuestionRules?: number;
  dontShowMarksAndRank?: number;
  marksMessage?: string;
  config?: any;
  testLayoutParameters?: any;
}

class TestCategoryService {
  private baseUrl = `${Config.nodeSiteUrl}v1/test-categories`;

  async listCategories(): Promise<TestCategory[]> {
    const resp: any = await myAxios.get(this.baseUrl);
    return resp.data.data;
  }

  async updateCategory(id: number, data: TestCategoryUpdateData): Promise<void> {
    await myAxios.put(`${this.baseUrl}/${id}`, data);
  }

  async updateMaxAttempts(id: number, maxAttempts: number): Promise<void> {
    await myAxios.put(`${this.baseUrl}/${id}/max-attempts`, { maxAttempts });
  }

  async createCategory(data: TestCategoryCreateData): Promise<any> {
    const resp: any = await myAxios.post(this.baseUrl, data);
    return resp.data.data;
  }

  async cloneCategory(id: number): Promise<any> {
    const resp: any = await myAxios.post(`${this.baseUrl}/${id}/clone`);
    return resp.data.data;
  }

  async toggleCategory(id: number): Promise<any> {
    const resp: any = await myAxios.patch(`${this.baseUrl}/${id}/toggle`);
    return resp.data.data;
  }
}

export default new TestCategoryService();
